module.exports = __webpack_public_path__ + "img/tree.34cdb322.png";